var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('MjGooglePermissions',{attrs:{"scope-prop":[{name: "Google Calendar",url: "https://www.googleapis.com/auth/calendar",authorized: false} ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }